import React from 'react';

import { CFG_MOBILE } from '../../../../theme/configurator-tokens';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { useIsTablet } from '../../lib/deviceType';
import { useConfigurator } from '../../store/configurator';
import { PreviewStageView } from './PreviewStageView';

/**
 * The persistent preview host, wired to its data source. A thin wrapper that reads
 * the live `previewUrl` + selected colour from the configurator store and the mobile
 * breakpoint, then renders {@link PreviewStageView} (the store-free presentational
 * core that owns the two warm iframes). Mount this once at provider scope, above the
 * route Outlet.
 */
export const PreviewStage = (): React.ReactElement | null => {
  const isMobile = useMediaQuery(CFG_MOBILE);
  // Tablets (iPad, Android tablets) get the desktop wizard by viewport width, but the
  // persistent morph iframes re-measure into an infinite-update crash on iPad Safari, so
  // the host is suppressed here and every surface renders static screenshots instead (see
  // useIsTablet / the tablet branches in PreviewPane, DevicePreview, PaymentSuccess).
  const isTablet = useIsTablet();
  const { previewUrl, selectedColor } = useConfigurator();
  return <PreviewStageView previewUrl={previewUrl} color={selectedColor} isMobile={isMobile || isTablet} />;
};

export default PreviewStage;
